import { cn } from '@/lib/utils';

export function SelectorButton({
  className,
  children,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        'flex flex-row place-items-center items-center justify-center gap-1 rounded border-0 bg-transparent px-2 py-1.5 text-sm hover:cursor-pointer hover:bg-slate-300/50',
        className,
      )}
    >
      {children}
    </button>
  );
}
